import type { ReactNode } from 'react';

/**
 * The report's section pattern (design prototype `.sec` / `.sec__title`):
 * a 16px bold title with an optional muted hint on its own line, sitting
 * OUTSIDE the card — the card below carries only content. Every report tab
 * composes its sections with this instead of CardHeader/CardTitle.
 */
export default function Section({
  title,
  hint,
  children,
}: {
  title: string;
  hint?: string;
  children: ReactNode;
}) {
  return (
    <section className="mb-6.5">
      <h2 className="mb-3.5 text-base font-bold leading-tight tracking-[-0.01em] text-foreground">
        {title}
        {hint && (
          <span className="mt-0.5 block text-xs font-normal tracking-normal text-muted-foreground">
            {hint}
          </span>
        )}
      </h2>
      {children}
    </section>
  );
}
